import React, { Component } from "react"
import { Table } from "antd"


// 订单号
// 套餐名称
// 套餐状态
// 套餐开通时间
// 有效截止时间
// 已用数据量（次）
// 剩余数据量（次）
const columns = [
    {
        title: '订单号',
        dataIndex: 'name',
        key: 'name',
        // render: text => <a>{text}</a>,
    },
    {
        title: '套餐名称',
        dataIndex: 'age',
        key: 'age',
    },
    {
        title: '套餐状态',
        dataIndex: 'address',
        key: 'address',
    },
    {
        title: '套餐开通时间',
        dataIndex: 'age',
        key: 'age',
    },
    {
        title: '有效截止时间',
        dataIndex: 'address',
        key: 'address',
    },
    {
        title: '已用数据量（次）',
        dataIndex: 'age',
        key: 'age',
    },
    {
        title: '剩余数据量（次）',
        dataIndex: 'address',
        key: 'address',
    },

]
class Combo extends Component {

    render () {
        const data = [
            {
                key: '1',
                name: 'John Brown',
                age: 32,
                address: 'New York No. 1 Lake Park',
                tags: ['nice', 'developer'],
            },
            {
                key: '2',
                name: 'Jim Green',
                age: 42,
                address: 'London No. 1 Lake Park',
                tags: ['loser'],
            },
            {
                key: '3',
                name: 'Joe Black',
                age: 32,
                address: 'Sidney No. 1 Lake Park',
                tags: ['cool', 'teacher'],
            },
        ]

        return (
            <div>
                <div className="welcome">
                    <div style={{ width: '100%', display: 'flex', justifyContent: "space-between", padding: '0 20px' }}>
                        <div className="font-20-l28">
                            套餐
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div style={{ padding: '16px 12px 70px 12px' }}>

                        <div className="row pb-3" style={{ marginLeft: '0px', marginRight: '0px' }}>
                            <div className="col-12" style={{ padding: '0 8px' }}>
                                <div className="bg-white mb-3">
                                    <div className="a-card-header">
                                        <div className="mx-2 d-flex justify-content-between align-items-center">
                                            <div className="font-16-l24">套餐详情</div>
                                            <div className="font-LH-14 color-black-85 font-weight-normal">

                                            </div>
                                        </div>
                                    </div>

                                    <div className="px-4 p-3">
                                        <Table columns={columns} dataSource={data} />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default Combo
